export default "__VITE_ASSET__ra3cVby4__"